import { render } from "./CommonFooter.vue?vue&type=template&id=60736d40"
import script from "./CommonFooter.vue?vue&type=script&lang=js"
export * from "./CommonFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kadowakikiyomi/Documents/PEARLY_GATES/CATALOGUE/PG/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__